import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { Route } from '../../config/router'
import { TrackingEvent } from '../../model/monitoring'
import { ErrorHandler, CheckoutErrorContext } from './types'
import { AFFORDABILITY_ERROR_CODES } from '../../model'

export const createCheckoutStartAffordabilityErrorHandler = (): ErrorHandler => {
  return {
    canHandle: (errorCode: ErrorCode, error: PortalApiError): boolean => {
      return AFFORDABILITY_ERROR_CODES.includes(errorCode)
    },

    handle: async (errorCode: ErrorCode, error: PortalApiError, context: CheckoutErrorContext): Promise<Route | undefined> => {
      context.logEvent(TrackingEvent.CHECKOUT_DECLINED, {
        isRecoverableTerminalError: false,
        errorCode,
      })

      return Route.AFFORDABILITY_QUESTION_FORM
    },
  }
}
